/* eslint-disable import/order */

import {
  appUpdateLogoutRequired,
  appUpdateRefreshOptional,
  appUpdateRefreshRequired,
  requestLogout,
  screenResize,
} from "actions";
import { appUpdateStatus } from "constants/system";
import "lib/logRocket/initialize";
import "lib/sentry/initialize";
import "lib/userflow/initialize";

import { createRoot } from "react-dom/client";
import "react-table-hoc-fixed-columns/lib/styles.css";
import "react-table/react-table.css";
import "react-toastify/dist/ReactToastify.css";

import "typeface-roboto";
import "./components/PageShell/animations.css";
import { GOOGLE_MAPS_API_KEY } from "./lib/googleMaps";
import {
  setGoogleMapsApiKey,
  setGoogleMapsApiLibraries,
} from "./lib/googleMaps/serviceManager";
import toast, {
  UPDATE_TOAST_MESSAGE,
  UPDATE_TOAST_MESSAGE_LOGOUT,
} from "./lib/toast";
import registerServiceWorker from "./registerServiceWorker";
import { debugServiceWorkerLog } from "lib/errors";
import sagas from "./sagas";
import configureStore from "./store/configureStore";
import { persistCallback } from "./store/persistCallback";

const container = document.getElementById("root");
const root = createRoot(container);

// Declare store as a local variable.
// It is generated by configureStore, which needs to build out discard and effect, but
// both of those need store to be available at run time, as does the peristCallback.
// As such - if you MUST use store directly, inject it where possible, or import the accessor
// getStore
// (At time of writting) the only places using store, via the getStore accessor are:
// discard
// effect
// persistCallback
// request.ts
// All of these receive the accessor via INJECTION - not via a direct import.

let store;
export function getStore() {
  return store;
}

const persistCallbackWrapper = () => {
  persistCallback(root, getStore);
};

store = configureStore(persistCallbackWrapper, getStore);

sagas.forEach(saga => store.runSaga(saga));

setGoogleMapsApiKey(GOOGLE_MAPS_API_KEY);
setGoogleMapsApiLibraries(["places"]);

window.addEventListener("resize", () => {
  const state = store.getState();
  if (state && state.screen.width !== window.innerWidth) {
    store.dispatch(screenResize(window.innerWidth));
  }
});

const handleUpdateFound = status => {
  debugServiceWorkerLog(`Handle Update Found - status: ${status}`);
  switch (status) {
    case appUpdateStatus.LOGOUT_REQUIRED:
      store.dispatch(requestLogout());
      store.dispatch(appUpdateLogoutRequired());
      toast.refreshPrompt(UPDATE_TOAST_MESSAGE_LOGOUT);
      break;

    case appUpdateStatus.REFRESH_REQUIRED:
      store.dispatch(appUpdateRefreshRequired());
      toast.refreshPrompt(UPDATE_TOAST_MESSAGE);
      break;

    case appUpdateStatus.REFRESH_OPTIONAL:
      store.dispatch(appUpdateRefreshOptional());
      break;

    case appUpdateStatus.INVISIBLE:
      // Do nothing
      /* eslint-disable-next-line no-console */
      console.log("App updates are ready to install");
      break;

    default:
  }
};

registerServiceWorker(handleUpdateFound);
